import { OverrideUserConfig } from 'react-match-breakpoints';

import { Breakpoint } from 'app/model/breakpoint';
import { BREAKPOINTS } from 'app/styles/breakpoints';

export class BreakpointsUtils {
    public static findWidth(breakpoints: OverrideUserConfig<boolean>): number {
        return BREAKPOINTS[BreakpointsUtils.findCurrentBreakpoint(breakpoints)];
    }

    public static findCurrentBreakpoint(breakpoints: OverrideUserConfig<boolean>): Breakpoint {
        return Object.keys(breakpoints).filter((k) => breakpoints[k as Breakpoint])[0] as Breakpoint;
    }

    public static isOnMobile(breakpoints: OverrideUserConfig<boolean>): boolean {
        return breakpoints.MOBILE || breakpoints.MOBILE_LANDSCAPE;
    }
}
